import React from 'react';
import MediaIcon from './MediaIcon';
import media from '../consts/media';

const Footer = ({ t }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          <div className="footer__info">
            <div className="footer__header">
              <div className="logo">
                <img src="/images/logo.svg" alt="logo" className="logo__img" />
                <div className="logo__name">Rajkumar</div>
              </div>
              <div className="footer__contact-group">
                <span className="footer__contact-item">
                  <a className="footer__email" href={media.email}>{media.emailRaw}</a>
                  <span className="footer__tooltip footer__tooltip--email">90% chances I reply ✉️</span>
                </span>
                <span className="footer__contact-divider">|</span>
                <span className="footer__contact-item">
                  <a className="footer__phone" href={`tel:${media.phone}`}>{media.phone}</a>
                  <span className="footer__tooltip footer__tooltip--phone">90% chances I don't pick up 📵</span>
                </span>
              </div>
            </div>
            <p className="footer__description">{t.description}</p>
          </div>
          <div className="footer__media">
            <div className="footer__title">{t.media}</div>
            <div className="footer__list">
              {["linkedin", "github", "email"].map((name) => (
                <MediaIcon key={name} name={name} />
              ))}
            </div>
          </div>
        </div>
        <div className="footer__copyright">© {t.copyright}</div>
      </div>
    </footer>
  );
};

export default Footer;